import React from "react";
import Logo from "../../asset/images/home/Logo (1).png";
import {Link} from "react-router-dom"; // adjust path if needed

function PaymentCard() {
    return (
        <>
            {/* Header */}
            <header className="bg-white shadow-md">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    <div className="flex justify-between items-center">

                        {/* Logo */}
                        <div className="flex items-center">
                            <img src={Logo} alt="READ 21 Logo" className="h-16 w-auto" />
                        </div>

                        {/* Navigation */}
                        <div className="flex items-center space-x-8">
                            <Link
                                to="/about"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                hover:bg-primaryDark hover:text-white transition-colors"
                            >
                                About
                            </Link>

                            <Link to="/register">
                                <button className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-primaryDark transition-colors text-lg">
                                    Enroll Today
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Section */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="bg-white rounded-xl shadow-lg p-10">

                        {/* Page Title & Stepper */}
                        <div className="mb-12">
                            <h1 className="text-3xl font-bold text-primary text-center mb-10">
                                Register Account
                            </h1>

                            <div className="relative flex items-center justify-between max-w-2xl mx-auto">

                                {/* Connecting Line */}
                                <div className="absolute left-[7%] right-[7%] top-4 h-0.5 bg-gray-300 z-0"></div>

                                {/* Step 1 Active */}
                                <div className="flex flex-col items-center relative z-10">
                                    <div className="w-8 h-8 rounded-full bg-white border-2 border-primary flex items-center justify-center mb-2">
                                        <svg
                                            className="w-5 h-5 text-primary"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                    <span className="text-sm text-primary">Registration</span>
                                </div>

                                {/* Step 2 */}
                                <div className="flex flex-col items-center relative z-10">
                                    <div className="w-8 h-8 rounded-full bg-white border-2 border-gray-300 flex items-center justify-center mb-2"></div>
                                    <span className="text-sm text-primary underline">Payment</span>
                                </div>

                                {/* Step 3 */}
                                <div className="flex flex-col items-center relative z-10">
                                    <div className="w-8 h-8 rounded-full bg-white border-2 border-gray-300 flex items-center justify-center mb-2"></div>
                                    <span className="text-sm text-primary">Complete</span>
                                </div>
                            </div>
                        </div>

                        {/* Back Button */}
                        <div className="mb-8">
                            <a
                                href="#"
                                className="flex items-center text-gray-600 hover:text-primary transition-colors"
                            >
                                <svg
                                    className="w-5 h-5 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M15 19l-7-7 7-7"
                                    />
                                </svg>
                                <span className="font-medium">Registration Details</span>
                            </a>
                        </div>

                        {/* Payment Form + Checkout */}
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                            {/* Payment Form */}
                            <div className="lg:col-span-2">
                                <div className="bg-[#E2F2FF] rounded-xl p-8">

                                    {/* Add New Card Header */}
                                    <div className="flex items-center justify-between mb-8">
                                        <div className="flex items-center">
                                            <div className="w-6 h-6 bg-green rounded-full flex items-center justify-center mr-3">
                                                <svg
                                                    className="w-4 h-4 text-white"
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </div>
                                            <span className="font-semibold text-gray-800">Add new card</span>
                                        </div>

                                        <div className="flex space-x-3">
                                            <img
                                                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                                                alt="Mastercard"
                                                className="h-6"
                                            />
                                            <img
                                                src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
                                                alt="Visa"
                                                className="h-6"
                                            />
                                        </div>
                                    </div>

                                    {/* Card Number Row */}
                                    <div className="grid grid-cols-12 gap-2 mb-6 items-start">
                                        <div className="col-span-4">
                                            <label className="block text-sm font-semibold text-gray-800 mt-3">
                                                Card number
                                            </label>
                                            <p className="text-xs text-gray-500 mt-1">
                                                Enter the 16-digit card number on the card
                                            </p>
                                        </div>

                                        <div className="col-span-7">
                                            <div className="relative">
                                                <input
                                                    type="text"
                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2
                          focus:ring-primary focus:border-transparent bg-white"
                                                    maxLength="16"
                                                />
                                                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                    <svg
                                                        className="w-6 h-6 text-gray-400"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0
                              00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-span-1">
                                            <button className="w-8 h-8 mt-2 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-50 bg-white">
                                                <svg
                                                    className="w-4 h-4 text-gray-500"
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0
                            01-1.414 0l-4-4a1 1 0
                            011.414-1.414L8 12.586l7.293-7.293a1 1 0
                            011.414 0z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    {/* Card Owner */}
                                    <div className="grid grid-cols-12 gap-6 mb-6 items-start">
                                        <div className="col-span-4">
                                            <label className="block text-sm font-semibold text-gray-800 mt-3">
                                                Card owner
                                            </label>
                                            <p className="text-xs text-gray-500 mt-1">
                                                Enter the name on the card
                                            </p>
                                        </div>
                                        <div className="col-span-7">
                                            <input
                                                type="text"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white
                        focus:ring-2 focus:ring-primary focus:border-transparent"
                                            />
                                        </div>
                                    </div>

                                    {/* Expiry Date */}
                                    <div className="grid grid-cols-12 gap-6 mb-6 items-start">
                                        <div className="col-span-4">
                                            <label className="block text-sm font-semibold text-gray-800 mt-3">
                                                Expiry date
                                            </label>
                                            <p className="text-xs text-gray-500 mt-1">
                                                Enter the expiry date of the card
                                            </p>
                                        </div>

                                        <div className="col-span-8">
                                            <div className="flex items-center space-x-3">
                                                <input
                                                    type="text"
                                                    placeholder="23"
                                                    maxLength="2"
                                                    className="w-20 px-4 py-3 border border-gray-300 rounded-lg
                          focus:ring-2 focus:ring-primary focus:border-transparent text-center bg-white"
                                                />

                                                <span className="text-gray-400 font-bold text-xl">/</span>

                                                <input
                                                    type="text"
                                                    placeholder="23"
                                                    maxLength="2"
                                                    className="w-20 px-4 py-3 border border-gray-300 rounded-lg
                          focus:ring-2 focus:ring-primary focus:border-transparent text-center bg-white"
                                                />

                                                <div className="col-span-4">
                                                    <label className="block text-sm font-semibold text-gray-800 mt-3">
                                                        CVV2
                                                    </label>
                                                    <p className="text-xs text-gray-500 mt-1">Security code</p>
                                                </div>

                                                <input
                                                    type="text"
                                                    placeholder="012"
                                                    maxLength="3"
                                                    className="w-28 px-4 py-3 border border-gray-300 rounded-lg
                          focus:ring-2 focus:ring-primary focus:border-transparent text-center bg-white"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Set Default */}
                                <div className="flex items-center pt-3 pl-1">
                                    <input
                                        type="checkbox"
                                        id="default"
                                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                                    />
                                    <label htmlFor="default" className="ml-2 text-sm">
                                        Set as default
                                    </label>
                                </div>
                            </div>

                            {/* Checkout */}
                            <div className="lg:col-span-1">
                                <div className="border p-6">

                                    <div className="flex items-center mb-6">
                                        <svg
                                            className="w-5 h-5 text-gray-700 mr-2"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707
                        1.707H17m0
                        0a2 2 0
                        100 4 2 2 0
                        000-4zm-8 2a2 2 0
                        11-4 0 2 2 0
                        014 0z"
                                            />
                                        </svg>

                                        <h3 className="font-semibold text-gray-800">Checkout</h3>
                                    </div>

                                    {/* Course Details */}
                                    <div className="mb-6">
                                        <div className="flex justify-between text-sm mb-2">
                                            <span className="text-gray-600">Course Name</span>
                                            <span className="text-gray-800 font-medium">Price</span>
                                        </div>

                                        <div className="flex justify-between items-center py-3 border-t border-gray-200">
                                            <span className="text-gray-800">Fast Track to Reading</span>
                                            <span className="font-semibold text-gray-800">$650</span>
                                        </div>
                                    </div>

                                    {/* Total */}
                                    <div className="border-t border-gray-300 pt-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-800 font-medium">Total:</span>
                                            <span className="text-2xl font-bold text-gray-900">$550.00</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Review Order Button */}
                                <Link to="/register/payment-detail">
                                    <button
                                        className="mt-5 w-full rounded-lg bg-green hover:bg-greenDark
                    text-white font-semibold py-3 px-6 transition-colors shadow-md"
                                    >
                                        Review your order
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-primary py-10">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <div className="mb-3">
                        <img
                            src={Logo}
                            alt="READ 21 Logo"
                            className="mx-auto h-16 w-auto"
                        />
                    </div>
                    <p className="text-white text-lg">Read 21 © 2025 - All Rights Reserved</p>
                </div>
            </footer>
        </>
    );
}

export default PaymentCard;
